export const TWEET_TYPE_NAME = `Twitter`
export const REDDIT_TYPE_NAME = `Reddit`
export const HN_TYPE_NAME = `Hacker News`
export const PH_TYPE_NAME = `Product Hunt`
export const REDIRECT_TYPE_NAME = `Google News`
export const YOUTUBE_TYPE_NAME = `Youtube`
export const SOCIAL_MEDIA_TYPE_NAME = `SocialMediaPost`
export const POST_TYPE_NAME = `MdxBlogPost`
export const INSTAGRAM_TYPE_NAME = `Instagram`
